import { options } from './Options'

const lineOfBusinesses = {
  '': '',
  lifeinsurance: 'Life Insurance',
  collectiveinvestmentscheme: 'Collective Investment Scheme',
  'group-eb': 'Group (EB) - Package',
  'group-eb-tailored': 'Group (EB) - Tailored',
  'gi-ae': 'GI - A & H (Individual)',
  'gi-motors': 'GI - Motors (Personal)',
  'gi-motors-commercial': 'GI - Motors (Commercial)',
  'gi-travel': 'GI - Travel (Individual)',
  'gi-travel-corporate': 'GI - Travel (Corporate)',
  'gi-homecontents': 'GI - Home Insurance',
  'gi-clines': 'GI - Commercial Lines',
  'gi-plines': 'GI - Personal Accident (Individual)',
  'gi-plines-corporate': 'GI - Personal Accident (Corporate)',
  'gi-health-individual': 'GI - Health (Individual)',
  'gi-health-group': 'GI - Health (Group)',
  'gi-others': 'GI - Others',
  feebasedservice: 'Fee Based Service',
  others: 'Others'
}
export type LOBType = keyof typeof lineOfBusinesses | 'employeebenefits' | 'group-gi' | 'group-eb' | 'group-eb-tailored'
export const LineOfBusinessOptions: options[] = Object.keys(lineOfBusinesses).map(key => {
  return {
    label: lineOfBusinesses[key],
    value: key
  }
})

export const productTypes = [
  'Life',
  'CIS',
  'Referrals',
  'GI',
  'EB',
  'Trailer Fee',
  'Financial Planning',
  'Para Planning',
  'Business Financing',
  'Loan',
  'Other Services'
]
